import { createAction } from "redux-actions";

export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const updateNotification = createAction(UPDATE_NOTIFICATION);